import { motion } from "framer-motion";

export const Signature = () => {
  return (
    <section id="signature" data-testid="signature-section" className="bg-[#1A1512] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="max-w-3xl"
          >
            <span className="text-xs uppercase tracking-[0.35em] text-[#C8A88B]">
              The Haus Signature
            </span>
            <h2 className="mt-6 font-serif-display text-5xl font-light leading-[1.05] tracking-tight text-[#E6D5C3] lg:text-6xl">
              A clean aesthetic,
              <br />
              <em className="text-[#C8A88B]">an expensive look.</em>
            </h2>
            <p className="mt-8 max-w-md text-base font-light leading-relaxed text-[#A89B8F]">
              No heavy, overdone sets. The Haus signature is precise mapping, clean
              lines and lashes that look like they were always yours — just better.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
